import { type Enum } from '@webapp/infrastructure/types/Enum'

// Which primary category a PO bills to. The wire key stays
// `po-bill-to-location` (SystemPreferenceKeys.PO_BILL_TO_LOCATION).
export const POBillToPrimaryCategories = {
  PURCHASER_HOME: 0,
  ORDER: 1,
  HEADQUARTERS: 2,
} as const

export type POBillToPrimaryCategoryEnum = Enum<typeof POBillToPrimaryCategories>
